import { SiteLink } from 'interfaces/site-link.interface';

export const reportNoticeLink: SiteLink = {
    label: 'Zgloś kwestię prawną',
    href: '/report-notice/index.html',
    title: 'Zgloś kwestię prawną',
    rel: 'nofollow',
    icon: 'mail',
    weight: '600',
    target: '_blank'
};
